import { z } from 'zod';
import { useWebSocketServer } from '~/modules/websocket';

const MESSAGE_SCHEMA = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('user/online'),
        member_id: z.number(),
    }),
    z.object({
        type: z.literal('user/offline'),
        member_id: z.number(),
    }),
]);

type MessageType = z.infer<typeof MESSAGE_SCHEMA>;

/**
 * Hook to handle real-time user active status updates with the WebSocket server.
 */
export function useUserActiveStatusUpdates({
    onMessage,
}: {
    onMessage?: (message: MessageType) => void;
} = {}) {
    const { lastMessage, isConnected } = useWebSocketServer({
        schema: MESSAGE_SCHEMA,
        onMessage,
    });

    return {
        lastMessage,
        isConnected,
    };
}
